import { render, staticRenderFns } from "./ViewSubcustomer.vue?vue&type=template&id=443b87fe&scoped=true&"
import script from "./ViewSubcustomer.vue?vue&type=script&lang=js&"
export * from "./ViewSubcustomer.vue?vue&type=script&lang=js&"
import style0 from "./ViewSubcustomer.vue?vue&type=style&index=0&id=443b87fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443b87fe",
  null
  
)

export default component.exports